import { render, staticRenderFns } from "./FileImageSelector.vue?vue&type=template&id=96ff2c5c&scoped=true&"
import script from "./FileImageSelector.vue?vue&type=script&lang=js&"
export * from "./FileImageSelector.vue?vue&type=script&lang=js&"
import style0 from "./FileImageSelector.vue?vue&type=style&index=0&id=96ff2c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ff2c5c",
  null
  
)

export default component.exports